import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { apiClient } from '../apiClient';

function InviteAcceptPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  const [isAuthed, setIsAuthed] = useState(false);
  const [error, setError] = useState('');
  const [accepted, setAccepted] = useState(false);

  useEffect(() => {
    let mounted = true;
    const checkAuth = async () => {
      try {
        const data = await apiClient.get('/api/auth/me');
        if (mounted && data?.user_id) {
          setIsAuthed(true);
        }
      } catch (err) {
        // ignore
      } finally {
        if (mounted) setChecking(false);
      }
    };
    checkAuth();
    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    if (!isAuthed || !token || accepted) return;
    const acceptInvite = async () => {
      try {
        const data = await apiClient.post('/api/invites/accept', { token });
        setAccepted(true);
        const redirect = data.redirect || '/profile';
        setTimeout(() => navigate(redirect), 800);
      } catch (err) {
        setError(err.message || 'Unable to accept invite.');
      }
    };
    acceptInvite();
  }, [isAuthed, token, accepted, navigate]);

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="spinner"></div>
      </div>
    );
  }

  if (!isAuthed) {
    const redirect = `/invite/${token}`;
    return (
      <div className="min-h-screen flex items-center justify-center p-4">
        <div className="max-w-md w-full card-glass text-center">
          <h1 className="text-2xl font-bold mb-2">Accept Invite</h1>
          <p className="text-gray-400 mb-6">
            Log in or create an account to accept this invite.
          </p>
          <div className="flex flex-col gap-3">
            <button className="btn-primary" onClick={() => navigate(`/login?redirect=${encodeURIComponent(redirect)}`)}>
              Log In
            </button>
            <button className="btn-secondary" onClick={() => navigate(`/signup/invite/${token}`)}>
              Sign Up
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="max-w-md w-full card-glass text-center">
        <h1 className="text-2xl font-bold mb-2">Accepting Invite</h1>
        {error ? (
          <p className="text-red-400">{error}</p>
        ) : (
          <p className="text-gray-400">
            {accepted ? 'Invite accepted. Redirecting...' : 'Processing your invite...'}
          </p>
        )}
      </div>
    </div>
  );
}

export default InviteAcceptPage;
